import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
// import ModernLayout from '../components/modern_layout'; // NÃO VAMOS MAIS USAR O LAYOUT
import ModernLoader from "../components/modern_loader";
import { useGlobalToast } from "../components/modern_toast";
import usePageTitle from "../hooks/usePageTitle";
import api from "../services/api";
// Componentes modernos
import ModernHeader from "../components/modern_header"; // VAMOS USAR ESTE
import ModernCartSidebar from "../components/modern_cart_sidebar";

function ModernDetalhe() {
  const history = useHistory();
  const location = useLocation();
  const { addToast } = useGlobalToast();

  // Estados
  const [loading, setLoading] = useState(true);
  const [produto, setProduto] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [carrinho, setCarrinho] = useState([]);
  const [fotoAtiva, setFotoAtiva] = useState(0);
  const [quantidade, setQuantidade] = useState(1);
  const [cartSidebarOpen, setCartSidebarOpen] = useState(false);

  // Atualizar título da página dinamicamente quando produto for carregado
  usePageTitle(produto ? produto.descricao : "Carregando..."); // MODIFICADO: de produto.DESC_PRODUTO

  useEffect(() => {
    let isComponentMounted = true;

    // --- FUNÇÃO DE CARRINHO CORRIGIDA (Baseada na ModernHome) ---
    const carregarCarrinho = async () => {
      console.log("🔄 INÍCIO carregarCarrinho - Detalhe");
      const login = sessionStorage.getItem("login");

      if (login && !login.includes("/")) {
        console.log("👤 Usuário logado, buscando carrinho do servidor...");
        try {
          const response = await api.post("buscar_interesses", {
            usuario: login,
            loja: sessionStorage.getItem("loja") || "1",
          });

          if (response?.data?.car && isComponentMounted) {
            const itemsAgrupados = {};
            response.data.car.forEach((item) => {
              const itemId = item.id;
              const qtde = item.quantidade || item[item.id]?.carrinho || 1;
              if (itemsAgrupados[itemId]) {
                itemsAgrupados[itemId].quantidade += qtde;
              } else {
                itemsAgrupados[itemId] = {
                  id: itemId,
                  nome: item.nome || item.descricao || `Produto ${itemId}`,
                  preco: item.preco || item[item.id]?.preco || 0,
                  quantidade: qtde,
                  img: item.img || item[item.id]?.img || "",
                  estoque: item.estoque || item[item.id]?.estoque || 0,
                };
              }
            });
            const carrinhoModerno = Object.values(itemsAgrupados);
            setCarrinho(carrinhoModerno);
            const sessao = carrinhoModerno.map((item) => JSON.stringify(item));
            sessionStorage.setItem("comprar", sessao.join(";"));
          } else {
            setCarrinho([]);
          }
        } catch (error) {
          console.warn("Erro ao buscar carrinho do servidor:", error);
          setCarrinho([]);
        }
      } else {
        console.log("🔒 Usuário não logado, buscando carrinho local...");
        const carrinhoStorage = sessionStorage.getItem("comprar");
        if (carrinhoStorage && isComponentMounted) {
          const items = [];
          carrinhoStorage.split(";").forEach((element) => {
            if (!element) return;
            try {
              const item = JSON.parse(element);
              if (item.quantidade !== undefined) {
                items.push(item);
              } else if (item.id) {
                const itemModerno = {
                  id: item.id,
                  nome: item.nome || `Produto ${item.id}`,
                  preco: item[item.id]?.preco || 0,
                  quantidade: item[item.id]?.carrinho || 1,
                  img: item[item.id]?.img || "",
                  estoque: item[item.id]?.estoque || 0,
                };
                items.push(itemModerno);
              }
            } catch (error) {
              console.warn("Erro ao parsear item do carrinho:", error);
            }
          });
          setCarrinho(items);
        } else {
          setCarrinho([]);
        }
      }
    };
    // --- FIM DA FUNÇÃO DE CARRINHO ---

    const buscarProduto = async (produtoId) => {
      try {
        console.log("🔍 Buscando produto:", produtoId);
        const response = await api.post("buscar_produto_detalhes", {
          produto: produtoId,
          id_loja: sessionStorage.getItem("loja") || "1",
        });

        console.log("📦 Resposta da API:", response);

        if (response?.data?.data && isComponentMounted) {
          const produtoData = {
            id: produtoId,
            altura: response.data.data.ALTURA,
            descricao: response.data.data.DESC_PRODUTO, // MODIFICADO: 'descricao'
            espessura: response.data.data.ESPESSURA,
            grupo: response.data.data.GRUPO_PRODUTO,
            largura: response.data.data.LARGURA,
            observacoes: response.data.data.OBS_IDEIA,
            peso: response.data.data.PESO,
            preco: response.data.data.PRECO1,
            estoque: response.data.data.ESTOQUE || 0, // MODIFICADO: Campo 'estoque' adicionado
          };

          console.log("✅ Produto processado:", produtoData);
          setProduto(produtoData);

          if (response.data.fotos) {
            console.log("📸 Fotos encontradas:", response.data.fotos);
            setFotos(response.data.fotos);
          }
        } else {
          console.warn("⚠️ Produto não encontrado na resposta da API");
          if (isComponentMounted) {
            addToast("Produto não encontrado", "error");
          }
        }
      } catch (error) {
        console.error("❌ Erro ao buscar produto:", error);
        if (isComponentMounted) {
          addToast("Erro ao carregar detalhes do produto", "error");
        }
      }
    };

    const initializePage = async () => {
      try {
        if (!isComponentMounted) return;
        setLoading(true);

        await carregarCarrinho(); // Chama a função de carrinho corrigida

        const urlParams = new URLSearchParams(location.search);
        const produtoId = urlParams.get("id") || urlParams.get("prod");

        console.log("🌐 Parâmetros da URL:", {
          produtoId,
          search: location.search,
        });

        if (produtoId) {
          await buscarProduto(produtoId);
        } else {
          console.warn("⚠️ ID do produto não encontrado na URL");
          if (isComponentMounted) {
            addToast("Produto não encontrado", "error");
            history.push("/");
          }
        }
      } catch (error) {
        console.error("❌ Erro ao carregar página:", error);
        if (isComponentMounted) {
          addToast("Erro ao carregar produto", "error");
        }
      } finally {
        if (isComponentMounted) {
          setLoading(false);
        }
      }
    };

    initializePage();

    // --- AJUSTE BFCache ---
    const handlePageShow = (event) => {
      if (event.persisted) {
        console.log(
          "🔄 BFCache restore detectado em Detalhe. Re-inicializando..."
        );
        // Reseta a quantidade para 1, pois pode vir de um estado "sujo"
        setQuantidade(1);
        // Roda a inicialização novamente para buscar dados frescos
        initializePage();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    // --- FIM AJUSTE BFCache ---

    return () => {
      isComponentMounted = false;
      window.removeEventListener("pageshow", handlePageShow); // Limpa o listener
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // --- FUNÇÃO handleAddToCart (Baseada na ModernHome e adaptada) ---
  const handleAddToCart = async () => {
    if (!produto) return;

    try {
      console.log(`🛒 Adicionando ${quantidade}x ${produto.id} ao carrinho...`);

      // 1. Formatar dados do produto (lendo do estado 'produto')
      const produtoData = {
        id: produto.id,
        nome: produto.descricao || `Produto ${produto.id}`,
        preco: produto.preco || 0,
        img: fotos[0] || "", // Pega a primeira foto
        estoque: produto.estoque || 0,
      };

      console.log("📦 Dados do produto formatados:", produtoData);

      // 2. Calcular nova quantidade
      const carrinhoAtualTemp = [...carrinho];
      const produtoExistenteTemp = carrinhoAtualTemp.find(
        (item) => item.id === produtoData.id
      );

      const quantidadeAdicionar = quantidade; // Do estado 'quantidade'
      const quantidadeNovaTotal = produtoExistenteTemp
        ? produtoExistenteTemp.quantidade + quantidadeAdicionar
        : quantidadeAdicionar;

      // 3. Salvar no banco (se logado)
      if (
        sessionStorage.getItem("login") &&
        !sessionStorage.getItem("login").includes("/")
      ) {
        const usuario = sessionStorage.getItem("login");
        const dict_itens = {
          usuario: usuario,
          loja: sessionStorage.getItem("loja") || "1",
          comprar: produtoData.id,
          quantidade: quantidadeNovaTotal, // Envia a quantidade TOTAL
        };

        console.log("💾 Tentando salvar no banco PRIMEIRO:", dict_itens);

        try {
          await api.post("add_session_db", { dict_itens });
          console.log("✅ Salvo no banco com sucesso");
        } catch (error) {
          console.error("❌ Erro ao salvar no banco:", error);
          let errorMessage =
            "Erro ao salvar produto no banco. Tente novamente.";
          addToast(errorMessage, "error");
          return; // Interrompe
        }
      }

      // 4. Atualizar estado local e sessionStorage
      const carrinhoAtual = [...carrinho];
      const produtoExistente = carrinhoAtual.find(
        (item) => item.id === produtoData.id
      );

      if (produtoExistente) {
        produtoExistente.quantidade += quantidadeAdicionar;
        console.log(
          "📈 Quantidade atualizada para:",
          produtoExistente.quantidade
        );
      } else {
        const novoItem = {
          ...produtoData,
          quantidade: quantidadeAdicionar,
        };
        carrinhoAtual.push(novoItem);
        console.log("➕ Novo item adicionado:", novoItem);
      }

      setCarrinho(carrinhoAtual);

      const sessao = carrinhoAtual.map((item) => JSON.stringify(item));
      sessionStorage.setItem("comprar", sessao.join(";"));

      setCartSidebarOpen(true); // Abrir sidebar
      addToast(`${produtoData.nome} adicionado ao carrinho!`, "success");
    } catch (error) {
      console.error("❌ Erro ao adicionar produto ao carrinho:", error);
      addToast(error.message || "Erro ao adicionar produto", "error");
    }
  };
  // --- FIM DA FUNÇÃO handleAddToCart ---

  const formatPrice = (price) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(price || 0);
  };

  if (loading) {
    return <ModernLoader message="Carregando detalhes do produto..." />;
  }

  if (!produto) {
    return (
      // MODIFICADO: Adicionando Header e Sidebar à tela de erro
      <>
        <ModernHeader
          callback={null} // Sem busca nesta página
          cartItems={carrinho}
          onCartClick={() => setCartSidebarOpen(true)}
        />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="text-center py-5">
                <i className="bi bi-exclamation-triangle fs-1 text-muted mb-3"></i>
                <h4>Produto não encontrado</h4>
                <p className="text-muted mb-4">
                  O produto que você está procurando não foi encontrado
                </p>
                <button
                  className="btn btn-modern"
                  onClick={() => history.push("/")}
                >
                  <i className="bi bi-arrow-left me-2"></i>
                  Voltar à loja
                </button>
              </div>
            </div>
          </div>
        </div>
        <ModernCartSidebar
          isOpen={cartSidebarOpen}
          onClose={() => setCartSidebarOpen(false)}
          cartItems={carrinho}
          onUpdateCart={(updatedItems) => {
            setCarrinho(updatedItems);
            const sessao = updatedItems.map((item) => JSON.stringify(item));
            sessionStorage.setItem("comprar", sessao.join(";"));
          }}
        />
      </>
    );
  }

  return (
    // --- LAYOUT MODIFICADO (como na modern_home) ---
    <div className="main-container">
      <ModernHeader
        callback={null} // Sem função de busca aqui
        cartItems={carrinho}
        onCartClick={() => setCartSidebarOpen(true)}
      />

      {/* Conteúdo da página (substituindo o ModernLayout) */}
      <div className="container mt-5">
        {/* Botão de Voltar (Manual) */}
        <div className="mb-3">
          <button
            className="btn btn-link text-decoration-none"
            onClick={() => history.goBack()}
          >
            <i className="bi bi-arrow-left me-2"></i>
            Voltar
          </button>
        </div>

        <div className="row g-4">
          {/* Galeria de fotos */}
          <div className="col-lg-6">
            <div className="modern-card">
              {fotos.length > 0 ? (
                <>
                  {/* Foto principal */}
                  <div className="position-relative">
                    <img
                      src={fotos[fotoAtiva]}
                      alt={produto.descricao}
                      className="w-100 rounded"
                      style={{
                        height: "400px",
                        objectFit: "contain",
                        backgroundColor: "#f8f9fa",
                      }}
                      onError={(e) => {
                        e.target.src =
                          "https://via.placeholder.com/400x400/e5e7eb/9ca3af?text=Produto";
                      }}
                    />

                    {/* Navegação de fotos */}
                    {fotos.length > 1 && (
                      <>
                        <button
                          className="btn btn-light position-absolute top-50 start-0 translate-middle-y ms-2"
                          onClick={() =>
                            setFotoAtiva(
                              fotoAtiva > 0 ? fotoAtiva - 1 : fotos.length - 1
                            )
                          }
                        >
                          <i className="bi bi-chevron-left"></i>
                        </button>
                        <button
                          className="btn btn-light position-absolute top-50 end-0 translate-middle-y me-2"
                          onClick={() =>
                            setFotoAtiva(
                              fotoAtiva < fotos.length - 1 ? fotoAtiva + 1 : 0
                            )
                          }
                        >
                          <i className="bi bi-chevron-right"></i>
                        </button>
                      </>
                    )}
                  </div>

                  {/* Thumbnails */}
                  {fotos.length > 1 && (
                    <div className="d-flex gap-2 mt-3 flex-wrap">
                      {fotos.map((foto, index) => (
                        <img
                          key={index}
                          src={foto}
                          alt={`${produto.descricao} - ${index + 1}`}
                          className={`cursor-pointer rounded border ${
                            index === fotoAtiva
                              ? "border-primary"
                              : "border-light"
                          }`}
                          style={{
                            width: "80px",
                            height: "80px",
                            objectFit: "cover",
                          }}
                          onClick={() => setFotoAtiva(index)}
                          onError={(e) => {
                            e.target.src =
                              "https://via.placeholder.com/80x80/e5e7eb/9ca3af?text=Img";
                          }}
                        />
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <div className="text-center py-5">
                  <i className="bi bi-image fs-1 text-muted mb-3"></i>
                  <p className="text-muted">Nenhuma imagem disponível</p>
                </div>
              )}
            </div>
          </div>

          {/* Informações do produto */}
          <div className="col-lg-6">
            <div className="modern-card">
              <div className="card-header">
                <h4 className="mb-0">{produto.descricao}</h4>
                <small className="text-muted">Grupo: {produto.grupo}</small>
              </div>

              <div className="card-body">
                {/* Preço */}
                <div className="mb-4">
                  <h3 className="text-success mb-0">
                    {formatPrice(produto.preco)}
                  </h3>
                </div>

                {/* Observações/Descrição detalhada */}
                {produto.observacoes && (
                  <div className="mb-4">
                    <h6>Descrição</h6>
                    {/* Usamos dangerouslySetInnerHTML para quebrar linhas e formatar
                      o texto caso contenha tags HTML como <br> ou entidades como &nbsp;.
                    */}
                    <p
                      className="text-muted"
                      dangerouslySetInnerHTML={{ __html: produto.observacoes }}
                    />
                  </div>
                )}

                {/* Especificações técnicas */}
                <div className="mb-4">
                  <h6>Especificações</h6>
                  <div className="row g-2">
                    {produto.peso && (
                      <div className="col-6">
                        <small className="text-muted">Peso:</small>
                        <div>{produto.peso}kg</div>
                      </div>
                    )}
                    {produto.altura && (
                      <div className="col-6">
                        <small className="text-muted">Altura:</small>
                        <div>{produto.altura}cm</div>
                      </div>
                    )}
                    {produto.largura && (
                      <div className="col-6">
                        <small className="text-muted">Largura:</small>
                        <div>{produto.largura}cm</div>
                      </div>
                    )}
                    {produto.espessura && (
                      <div className="col-6">
                        <small className="text-muted">Espessura:</small>
                        <div>{produto.espessura}cm</div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Quantidade e botão de adicionar */}
                <div className="row g-3">
                  <div className="col-4">
                    <label htmlFor="quantidade" className="form-label">
                      Quantidade
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      id="quantidade"
                      min="1"
                      value={quantidade}
                      onChange={(e) =>
                        setQuantidade(parseInt(e.target.value) || 1)
                      }
                    />
                  </div>
                  <div className="col-8 d-flex align-items-end">
                    {/* --- BOTÃO MODIFICADO --- */}
                    <button
                      className="btn btn-modern w-100 text-white"
                      onClick={handleAddToCart} // Corrigido de 'onAddToCart' para 'onClick'
                    >
                      <i className="bi bi-cart-plus me-2"></i>
                      Adicionar ao Carrinho
                    </button>
                    {/* --- FIM DA MODIFICAÇÃO --- */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Sidebar do Carrinho */}
      <ModernCartSidebar
        isOpen={cartSidebarOpen}
        onClose={() => setCartSidebarOpen(false)}
        cartItems={carrinho}
        onUpdateCart={(updatedItems) => {
          setCarrinho(updatedItems);
          // Atualizar sessionStorage
          const sessao = updatedItems.map((item) => JSON.stringify(item));
          sessionStorage.setItem("comprar", sessao.join(";"));
        }}
      />
    </div>
  );
}

export default ModernDetalhe;
